<template>
	<!--Words -->
	<div class="landing-words">
		<section class="content-articles" v-in-viewport="">
			<div class="inside">
				<div class="text-center headline-container" v-if="pageWord.header_text">
					<h1 class="headline" v-in-viewport="">{{pageWord.header_text.value}}</h1>
				</div>

				<button type="button" class="toggle-filter" @click="dropSelect()" :class="{isOpen:showSelect}">FILTER</button>
				<div class="filter-container container-fluid " v-if="(showSelect) || (!this.$breakpoints.isMobile()) ">
					<div class="filter" >
						<div class="select-container" :class="{isOpen:visibleCategories}">
							<dropdown :visible="visibleCategories" @clickOut="visibleCategories = false" :position="position" :animation="'ani-fade'">
								<span class="select" @click="visibleCategories = !visibleCategories">{{selectedCategoryTitle}}</span>
								<ul slot="dropdown">
									<li value="" @click="filterBy($event)" :title="'All Categories'">All Categories</li>
									<li v-for="option in taxonomyCategories" :title="option.name" :value="'&elements.word_category[all]='+option.codename" @click="filterBy($event)">{{option.name}}</li>
								</ul>
							</dropdown>
						</div>
						<div class="search-container">
							<input type="text" name="search" v-model="search">
							<img id="searchIcon" :src="searchIcon" alt="Search Icon">
						</div>
					</div>
				</div>
				<articles-wrapper :boxes="filteredArticles" :search="search" :isHome="false" :boxlimit="3" :pathRoute="'/words'" :showCategory="true"></articles-wrapper>
			</div>
		</section>
	</div>
</template>

<script>
	import apiConnection from '../mixins/apiConnection.js';
	import seoModule from '../mixins/seoModule.js';
	import articlesWrapper from '../components/articles-wrapper.vue';
	import dropdown from 'vue-my-dropdown';
	require('../assets/img/search-icon.svg');
	require('../assets/img/search-icon-white.svg');
	require('../assets/img/select-down.svg');
	require('../assets/img/select-down-white.svg');

	export default{
		name: 'Words',
		data () {
			return {
				pageWord:[],
				articles:[],
				taxonomyCategories:[],
				search:'',
				showSelect:false,
				visibleCategories:false,
				selectedCategory:'',selectedCategoryTitle:'All Categories',
				position: [ "left", "bottom", "left", "top" ]
			}
		},
		components:{
			'articles-wrapper':articlesWrapper,
			dropdown
		},
		created:function(){
			this.getWord();
			this.getArticles(1000);
			this.getTaxonomyCategories();
			window.addEventListener('resize', this.handleResize);
		},
		mounted: function() {
			setTimeout(function(){
				$('.st-sticky-share-buttons').removeClass('st-sticky-share-buttons-show')
			},500);

		},
		removed:function(){
			window.removeEventListener('resize', this.handleResize);
		},
		mixins:[apiConnection,seoModule],
		methods:{
			filterBy:function(event){
				this.selectedCategoryTitle =event.target.attributes.title.value;
				this.filterArticles(event.target.attributes.value.value);
				this.visibleCategories = !this.visibleCategories;
			},
			dropSelect:function(){
				this.showSelect = !this.showSelect;
			},
			handleResize:function(){
				if(!this.$breakpoints.isMobile()) {
					this.showSelect = true;
					let icon = document.getElementById('searchIcon');
					if(icon) icon.src = 'dist/search-icon-white.svg';
				}
				else{
					let icon = document.getElementById('searchIcon');
					if(icon) icon.src = 'dist/search-icon.svg';
				}
			}
		},
		computed:{
			filteredArticles(){
				let result = this.articles;
				if(!this.search) return result;

				const search = this.search.toLowerCase();

				const filter = box =>
				box.elements.header_title.value.toLowerCase().includes(search) ||
				box.elements.word_category.value.some(value => value.name.toLowerCase().includes(search))
				return result.filter(filter);
			},
			searchIcon(){
				if(!this.$breakpoints.isMobile()) return 'dist/search-icon-white.svg';
				else return 'dist/search-icon.svg';
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Words.vue?342213f6